import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { connect, useDispatch } from "react-redux";
import { useHistory, withRouter, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart, faUser, faBell, faBars } from "@fortawesome/free-solid-svg-icons";

import {
  customerConstants,
  eventBookingConstants,
  messageBoardConstants,
  defaultEventSetupObject,
  shutterbDashboardConstants,
} from "../../../constants";
import { Images } from "../../../assets/images";
import {
  loginActions,
  eventBookingActions,
  messageBoardActions,
} from "../../../redux/actions";
import Modal from "../../Views/Login/Modal";
import { NavigateToPath } from "../../../system";
import { custom } from "../../../redux/actions/utilities";
import { startConnection } from "../../../system/signalRHOC";
import {
  customToast,
  deepClone,
  getFormattedFormState,
} from "../../../shared/utility";
import MessageBoardModal from "../../../shared/components/MessageBoard/Modal/MessageBoardModal";

const Topbar = (props) => {
  /* eslint-disable */
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const history = useHistory();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMessageModalOpen, setIsMessageModalOpen] = useState(false);
  const [isNotificationOpen, setIsNotificationOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const existingData = localStorage.getItem("dataToSend");
  const parsedData = JSON.parse(existingData);
  const [savedOrder, setSavedOrder] = useState(
    parsedData?.Event?.Order?.orderItems
  );
  const notNewEvent = localStorage.getItem(customerConstants.NOT_NEW_EVENT);
  const [isNavCollapsed] = useState(true);

  useEffect(() => {
    if (props.authentication || props.isShutterbAuthenticated) {
      const authUserId = props.authentication
        ? props.auth.userId
        : props.sbAuth.sbUserId;
      const authUserType = props.auth.userType;
      props.getUserNotificationCount(authUserId, authUserType);
    }
    const existingData = localStorage.getItem("dataToSend");
    const parsedData = JSON.parse(existingData);
    if (
      (savedOrder && savedOrder.length === 0) ||
      (parsedData?.Event?.Order?.orderItems &&
        parsedData?.Event?.Order?.orderItems !== existingData)
    ) {
      setSavedOrder(parsedData?.Event?.Order?.orderItems);
    }

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (props.authentication || props.isShutterbAuthenticated) {
      const setupConnection = async () => {
        try {
          // Establish the connection
          const newConnection = await startConnection(
            props.userId,
            0,
            null,
            props.authentication
              ? customerConstants.HOST
              : shutterbDashboardConstants.SHUTTERB
          );
          newConnection.on("ReceiveNotification", (message) => {
            newConnection.invoke(
              "NotificationsCount",
              message.receiverId,
              message.userType
            );
          });

          // Dispatch an action to update Redux state with the received message
          // Listen for notifications count
          newConnection.on("ReceiveNotificationsCount", (notificationCount) => {
            dispatch(
              custom(
                notificationCount,
                messageBoardConstants.GET_NOTIFICATION_COUNT
              )
            );
          });
        } catch (error) {
          console.error("Error setting up connection:", error);
        }
      };
      setupConnection();
    }
  }, [dispatch]);

  const updateCart = () => {
    const existingData = localStorage.getItem("dataToSend");
    const parsedData = JSON.parse(existingData);
    setSavedOrder(parsedData?.Event?.Order?.orderItems);
  };

  const handleBookNowClick = (e) => {
    window.dataLayer.push({
      event: "site_action",
      action: "book_now_header",
    });

    if (!notNewEvent) {
      if (props.isDraftEvent || props.isEditEvent) {
        props.resetEventBooking();
      } else {
        const formState = getFormattedFormState();
        props.setEventBookingFormState(formState);
      }

      NavigateToPath(history, "/event_booking", "/event_booking", 2);
    } else {
      props.emptyEventBookingRed();
      const tempToken = localStorage.getItem(process.env.REACT_APP_PAYLOAD);
      localStorage.clear();
      localStorage.setItem(process.env.REACT_APP_PAYLOAD, tempToken);
      localStorage.setItem(
        "activeTab",
        eventBookingConstants.TABS_ID.EVENT_SETUP
      );

      window.location.replace("/event_booking");
    }
  };

  const handleNotificationClick = (values) => {
    // Toggle the state to open/close the notification list
    setIsNotificationOpen(false);
    closeNotificationPanel();
    if (props.authentication) {
      props.setCustomerChatStart({ currentTabId: values.sbUserId });
      history.push(
        `/CustomerDashboardTab/MyEvents/${values.eventId}/${customerConstants.MESSAGE_BOARD}`
      );
    }
    if (props.isShutterbAuthenticated) {
      setIsMessageModalOpen(true);
    }
    props.bulkUpdateMessageStatus(
      values.eventId,
      values.sbUserId,
      props.auth.userId,
      props.auth.userType
    );
    props.getMessages(values.eventId, values.sbUserId);
    props.setFormState({
      ...props.formState,
      eventId: values.eventId,
      sbUserId: values.sbUserId,
      userId: values.userId,
      profileImageUrl: values.profileImageUrl,
      name: props.isShutterbAuthenticated
        ? values.hostName
        : values.shutterbName,
      senderId: props.isShutterbAuthenticated ? values.sbUserId : values.userId,
      receiverId: props.isShutterbAuthenticated
        ? values.userId
        : values.sbUserId,
      sender: props.authentication
        ? customerConstants.HOST
        : shutterbDashboardConstants.SHUTTERB,
    });
  };
  const openNotificationPanel = () => {
    document.getElementById("notificationSidebar").style.width = "330px";
    // document.getElementById("notification-main").style.marginRight = "250px";
    document.getElementById("notification-main").style.visibility = "visible";
  };

  const closeNotificationPanel = () => {
    document.getElementById("notificationSidebar").style.width = "0";
    document.getElementById("notification-main").style.marginRight = "0";
    document.getElementById("notification-main").style.visibility = "hidden";
  };

  return (
    <>
      <header
        id="topbar-header"
        className={`border-bottom border-1x ${isMenuOpen ? "pb-0" : ""}`}
      >
        <div className="main-header p-0">
          <nav
            className={`navbar navbar-expand-lg pl-0 pr-0 ${isMenuOpen ? "pb-0" : ""
              }`}
          >
            <div className="pl-md-5 pl-lg-4 pl-3 ml-md-4">
              <Link className="navbar-brand" to="#">
                <img
                  src={Images.ShutterbLogo}
                  onClick={() => {
                    window.location.href = `${process.env.REACT_APP_MARKETING_SITE_BASE_URL}`;
                  }}
                  alt=""
                />
              </Link>
            </div>
            <button
              className={`navbar-toggler ${isMenuOpen ? "" : "collapsed"}`}
              type="button"
              aria-controls="navbarResponsive"
              aria-expanded={isMenuOpen}
              aria-label="Toggle navigation"
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              <span className="navbar-toggler-icon">
                <FontAwesomeIcon icon={faBars} className="clr-blue" />
              </span>
            </button>

            <div
              className={`collapse navbar-collapse  pr-md-3 pr-lg-3 mr-md-3 ${isMenuOpen ? "show small-device-menu-items" : ""
                }`}
              id="navbarResponsive"
            >
              <ul className="navbar-nav help-ul ml-auto font-13">
                {props.authentication || props.isShutterbAuthenticated ? (
                  // logout btn
                  <li className="nav-item navbar-text pr-5">
                    <a
                      className="nav-link text-dark font-weight-bold font-13"
                      href="/"
                      data-toggle="modal"
                      data-target="#exampleModalLong"
                      onClick={() => {
                        props.onLogoutClick();
                      }}
                    >
                      Logout
                    </a>
                  </li>
                ) : (
                  // login btn
                  <li className="nav-item navbar-text pr-5">
                    <a
                      className="nav-link text-dark font-weight-bold font-13"
                      href="/"
                      onClick={() => {
                        NavigateToPath(history, "/Login");
                        setIsMenuOpen(false);
                      }}
                    >
                      LOGIN
                    </a>
                  </li>
                )}

                <li className="nav-item navbar-text pr-5">
                  <a
                    className="text-dark font-weight-bold font-13"
                    href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/our-story/`}
                  >
                    Our Story
                  </a>
                </li>

                <li className="nav-item navbar-text pr-5">
                  <a
                    className="text-dark font-weight-bold font-13"
                    href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/faq/`}
                  >
                    FAQ
                  </a>
                </li>

                <li className="nav-item navbar-text pr-5">
                  <a
                    href="#"
                    className="text-dark font-weight-bold font-13"
                    onClick={() => {
                      NavigateToPath(history, "/be-a-shutterb");
                      setIsMenuOpen(false);
                    }}
                  >
                    Be a ShutterB
                  </a>
                </li>

                <li className="nav-item navbar-text pr-4">
                  <a
                    className="text-dark font-weight-bold font-13"
                    href={`${process.env.REACT_APP_MARKETING_SITE_BASE_URL}/business/`}
                  >
                    Business
                  </a>
                </li>
                {/* cart icon for customer */}
                {props.authentication ? (
                  <li
                    className="nav-item pl-1 pr-2 d-flex font-13"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {window.location.pathname.includes(
                      customerConstants.DRAFT_EVENT_TOP_BAR_CHECK
                    ) ? (
                      <a className="text-dark font-weight-bold font-13">
                        <li>
                          <FontAwesomeIcon icon={faShoppingCart} />
                        </li>
                      </a>
                    ) : !notNewEvent ? (
                      <a
                        className="text-dark font-weight-bold font-13"
                        onClick={() => {
                          updateCart();
                          if (
                            localStorage.hasOwnProperty("dataToSend") &&
                            JSON.parse(localStorage.getItem("dataToSend"))
                              ?.Event?.Order?.orderItems?.length > 0
                          ) {
                            localStorage.setItem(
                              "activeTab",
                              eventBookingConstants.TABS.CART
                            );
                            NavigateToPath(
                              history,
                              "/event_booking",
                              "/event_booking",
                              2
                            );
                          } else {
                            if (JSON.parse(localStorage.getItem("activeTab"))) {
                              if (
                                JSON.parse(
                                  localStorage.getItem("activeTab")
                                ) === eventBookingConstants.TABS.CART &&
                                savedOrder?.length === 0
                              ) {
                                localStorage.setItem(
                                  "activeTab",
                                  eventBookingConstants.TABS.SELECT_SHUTTERB
                                );
                              }
                            }
                            customToast(t("cart_is_empty"), toast.TYPE.ERROR);
                          }
                        }}
                      >
                        <li>
                          <FontAwesomeIcon icon={faShoppingCart} />
                        </li>
                      </a>
                    ) : (
                      <a
                        className="text-dark font-13"
                        onClick={() => {
                          if (props.customerDashboardCart.length > 0) {
                            localStorage.setItem(
                              "activeTab",
                              eventBookingConstants.TABS_ID.CART
                            );
                            NavigateToPath(
                              history,
                              "/event_booking",
                              "/event_booking",
                              2
                            );
                          } else {
                            localStorage.removeItem("activeTab");
                            customToast(t("cart_is_empty"), toast.TYPE.ERROR);
                          }
                        }}
                      >
                        <li>
                          <FontAwesomeIcon icon={faShoppingCart} />
                        </li>
                      </a>
                    )}
                  </li>
                ) : (
                  ""
                )}

                {/* dashboard icon for sb and customer */}
                {props.authentication || props.isShutterbAuthenticated ? (
                  <li
                    className="nav-item pl-1"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <a
                      href="#"
                      className="text-dark font-weight-bold font-13 m-0"
                      onClick={() => {
                        if (props.isShutterbAuthenticated) {
                          window.location.href = `${process.env.REACT_APP_HOST_BASE_URL}/Shutterbdashboard`;
                        } else {
                          window.location.href = `${process.env.REACT_APP_HOST_BASE_URL}/CustomerDashboard`;
                        }
                      }}
                    >
                      <FontAwesomeIcon icon={faUser} className="text-dark mr-3" />
                    </a>
                  </li>
                ) : (
                  ""
                )}
                {props.authentication || props.isShutterbAuthenticated ? (
                  <li className="nav-item pl-1 pr-4">
                    <a
                      href=""
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isNotificationOpen) {
                          props.getNotifications(
                            props.auth.userId,
                            props.auth.userType
                          );
                          props.getUserNotificationCount(
                            props.auth.userId,
                            props.auth.userType
                          );
                        }
                        // setIsNotificationOpen(!isNotificationOpen);
                        openNotificationPanel();
                      }}
                      className="clr-white font-13"
                    >
                      <FontAwesomeIcon icon={faBell} className="text-dark" />
                      {props.notificationCount > 0 ? (
                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-light">
                          {props.notificationCount}
                        </span>
                      ) : (
                        ""
                      )}
                    </a>
                  </li>
                ) : (
                  ""
                )}
              </ul>
              <ul className={`contact_search ${isMenuOpen ? "pt-2" : ""}`}>
                <li className="contact" onClick={() => setIsMenuOpen(false)}>
                  <span
                    onClick={handleBookNowClick}
                    className={`${props.isShutterbAuthenticated
                        ? "book-now-disabled d-none"
                        : "book-now"
                      } text`}
                  >
                    BOOK NOW
                  </span>
                </li>
              </ul>
            </div>
          </nav>
          <input type="hidden" value="/" id="site_url" />
        </div>
      </header>
      {isModalOpen && <Modal setIsModalOpen={setIsModalOpen} />}
      <div id="notification-main">
        <div
          id="notificationSidebar"
          className="notification-sidebar notification-zindex"
        >
          <div className="closebtn">
            <p className="notification-heading d-flex justify-content-start align-items-center">
              <b>notifications</b>
            </p>
            <span
              href="javascript:void(0)"
              className="d-flex justify-content-end"
              onClick={() => closeNotificationPanel()}
              style={{ cursor: "pointer" }}
            >
              &times;
            </span>
          </div>
          {props.notifications?.length > 0 ? (
            props.notifications.map((item) => {
              return (
                <a
                  className="border-bottom text-dark"
                  style={{ cursor: "text" }}
                >
                  <div className="row m-0 p-0">
                    <div className="col-2 m-0 p-0">
                      <img
                        className="rounded-circle notification-img"
                        src={
                          props.authentication && item.profileImageUrl
                            ? process.env.REACT_APP_S3_BASE_URL_PORTFOLIO +
                            "/" +
                            item.profileImageUrl
                            : Images.Avatar
                        }
                      />
                    </div>
                    <div className="col m-0 p-0">
                      <div className="m-0 text-break text-dark sidebar-notifications text">
                        <b>
                          {props.authentication
                            ? item.shutterbName
                            : item.hostName}
                        </b>
                        <p className="mb-0 text">
                          sent you a message against {item.eventName}
                        </p>
                      </div>
                    </div>
                  </div>
                </a>
              );
            })
          ) : (
            <p className="m-0 text-dark empty-notification-panel text">
              no notifications to view
            </p>
          )}
        </div>
      </div>
      <MessageBoardModal
        isModalOpen={isMessageModalOpen}
        setIsModalOpen={setIsMessageModalOpen}
        currentUser={props.authentication ? props.userId : props.sbUserId}
        className="message-board-modal"
      />
    </>
  );
};

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  authentication: state.authentication.isAuthenticated,
  isShutterbAuthenticated: state.shutterbAuthentication.isShutterbAuthenticated,
  userId: state.authentication.userId,
  sbUserId: state.shutterbAuthentication.sbUserId,
  customerDashboardCart: state.customerDashboard.customerDashboardCart,
  auth: state.authentication,
  sbAuth: state.shutterbAuthentication,
  notifications: state.messageBoard.notifications,
  notificationCount: state.messageBoard.notificationCount,
  isDraftEvent: state.eventBooking.isDraftEvent,
  isEditEvent: state.eventBooking.isEditEvent,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  onLogoutClick: () => dispatch(loginActions.logout()),
  emptyEventBookingRed: () => {
    dispatch({
      data: [deepClone(defaultEventSetupObject)],
      type: eventBookingConstants.SET_FORM_STATE,
    });
    dispatch({ data: [], type: eventBookingConstants.SELECTED_SHUTTER_BS });
    dispatch({ data: false, type: eventBookingConstants.SET_CART_TAB });
    dispatch({
      data: [],
      type: customerConstants.UPDATE_CUSTOMER_DASHBOARD_CART,
    });
  },
  getNotifications: (id, type) =>
    dispatch(messageBoardActions.getNotifications(id, type)),
  getMessages: (eventId, sbUserId) =>
    dispatch(messageBoardActions.getMessages(eventId, sbUserId)),
  setFormState: (data) => dispatch(messageBoardActions.setFormState(data)),
  bulkUpdateMessageStatus: (eventId, sbUserId, userId, userType) =>
    dispatch(
      messageBoardActions.bulkUpdateMessageStatus(
        eventId,
        sbUserId,
        userId,
        userType
      )
    ),
  getUserNotificationCount: (id, type) =>
    dispatch(messageBoardActions.getUserNotificationCount(id, type)),
  setCustomerChatStart: (data) =>
    dispatch(messageBoardActions.setCustomerChatStart(data)),
  setEventBookingFormState: (data) =>
    dispatch(eventBookingActions.setFormState(data)),
  resetEventBooking: () => dispatch(eventBookingActions.resetEventBooking()),
});

// mapping action and store the function via props
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Topbar));
